import { render } from "./user-bookings-modal.vue?vue&type=template&id=0da0fa5a"
import script from "./user-bookings-modal.vue?vue&type=script&lang=js"
export * from "./user-bookings-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__